module.exports = __webpack_public_path__ + "img/videi-icon.6b56fe82.svg";